interface TrendBadgeProps {
    value: number;
    label?: string;
    className?: string;
}

export function TrendBadge({ value, label = "this week", className = "" }: TrendBadgeProps) {
    // Determine the trend direction and styling
    const isPositive = value > 0;
    const isNegative = value < 0;
    const isNeutral = value === 0;

    // Determine background and text colors based on trend
    const bgColorClass = isPositive
        ? "bg-green-50 border-green-100"
        : isNegative
          ? "bg-red-50 border-red-100"
          : "bg-sky-50 border-sky-100";

    const textColorClass = isPositive ? "text-green-700" : isNegative ? "text-red-700" : "text-sky-700";

    // Format the value with appropriate sign
    const formattedValue = isPositive
        ? `+${value}`
        : isNeutral
          ? `${value}` // Just show 0 for neutral
          : `${value}`; // Negative values already have minus sign

    return (
        <div className={`flex items-center gap-1 px-2 py-1 border rounded-full ${bgColorClass} ${className}`}>
            <span className={`text-xs ${textColorClass}`}>
                {formattedValue} {label}
            </span>
        </div>
    );
}
